const initialState = {
    anchor: 'left',
    banner: [],
    open: false,
    id: '',
    versao: 0,
    nome: '',
    link: '',
    descricao: '',
    caminho_imagem: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function banner(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_BANNER':
            return {
                ...state,
                banner: action.banner
            };
        case 'BANNER_DETAIL':
            return {
                ...state,
                id: action.id,
                banner: action.banner,
                nome: action.nome,
                descricao: action.descricao,
                caminho_imagem: action.caminho_imagem,
                link: action.link,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case 'BANNER_CLEAR':
            return {
                ...state,
                anchor: 'left',
                banner: [],
                open: false,
                id: '',
                nome: '',
                descricao: '',
                caminho_imagem: '',
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                link: '',
            };
        case "BANNER_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
